import React, { useState } from "react";
import { Button, Space, Modal, Form, Input, Select, Spin, message } from 'antd';
import { InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";
import { bookADemo } from "../ducks/services"; // Adjust the import path as necessary
const antIcon = <LoadingOutlined spin />;

const { Option } = Select;

const BOOK_A_DEMO_LEARNMORE_URL = process.env.BOOK_A_DEMO_LEARNMORE_URL;

const learnMore = (url) => {
  window.open(url, "_blank");
};

const Banner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [load, setLoad] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setLoad(true);
    form
      .validateFields()
      .then((values) => {
        bookADemo(values)
          .then((response) => {
            setLoad(false);
            // Handle success response
            if (response?.data?.header?.code == 200 && response?.data?.header?.message === "Demo request submitted successfully") {
              // Reset form and close modal
              form.resetFields();
              setIsModalOpen(false);
              setSuccessModalVisible(true);
            }
            else {
              // Handle error response
              console.error("Error booking demo:", response.data.header.message);
              message.error(response?.data?.header?.message || "Demo request failed!");
            }
          })
          .catch((error) => {
            message.error(error?.response?.data?.header?.message || "Something went wrong.");
            setLoad(false);
          });
      })
      .catch((errorInfo) => {
        setLoad(false);
        console.error("Validation Failed:", errorInfo);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleSuccessOk = () => {
    setSuccessModalVisible(false);
  };

  return (
    <div>
      <div style={{ background: '#f4f0ff', padding: "16px", borderRadius: "10px", marginBottom: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "20px", color: "#333" }}>
          <InfoCircleFilled style={{ color: "rgb(111, 91, 246)", fontSize: "22px" }} />
          <div style={{ fontSize: "22px" }}>
            <strong>Introducing the all-new Password Manager</strong> — Secure everything from your passwords to bank details, credit cards, and more!
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          <Space>
            <Button type="primary" onClick={showModal}>
              Book a demo
            </Button>
            <Button onClick={() => learnMore(`${BOOK_A_DEMO_LEARNMORE_URL}`)}>
              Learn more
            </Button>
          </Space>
        </div>
      </div>


      {/* Booking Form Modal */}
      <Modal
        title={<><strong><span style={{ fontSize: "20px" }}>Book a Demo</span></strong><div><span style={{ fontSize: "12px" }}>Enter the details and submit a request</span></div></>
        }
        closable={false}
        centered
        width={600}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Close"
        bodyStyle={{ padding: "20px" }}
      >
        <Spin indicator={antIcon} size="large" spinning={load}>
          <Form form={form} layout="vertical" name="book_demo_form">
            <Form.Item
              name="name"
              label={<strong style={{ color: "#333" }}>Name</strong>}
              rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input placeholder="Your name" />
            </Form.Item>

            <Form.Item
              name="company"
              label={<strong style={{ color: "#333" }}>Company Name</strong>}
              rules={[{ required: true, message: "Please enter your company name" }]}
            >
              <Input placeholder="Company name" />
            </Form.Item>

            <Form.Item
              name="requestNeed"
              label={<strong style={{ color: "#333" }}>Request Need</strong>}
              rules={[{ required: true, message: "Please describe your need" }]}
            >
              <Input.TextArea rows={3} placeholder="What would you like to discuss in the demo?" />
            </Form.Item>

            <Form.Item
              name="companySize"
              label={<strong style={{ color: "#333" }}>Company Size</strong>}
              rules={[{ required: true, message: "Please select your company size" }]}
            >
              <Select placeholder="Select company size">
                <Option value="1-10">1-10</Option>
                <Option value="11-50">11-50</Option>
                <Option value="51-200">51-200</Option>
                <Option value="201-500">201-500</Option>
                <Option value="501-1000">501-1000</Option>
                <Option value="1000+">1000+</Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="industry"
              label={<strong style={{ color: "#333" }}>Industry</strong>}
              rules={[{ required: true, message: "Please select your industry" }]}
            >
              <Select placeholder="Select industry">
                <Option value="Finance">Finance</Option>
                <Option value="Healthcare">Healthcare</Option>
                <Option value="Education">Education</Option>
                <Option value="Technology">Technology</Option>
                <Option value="Retail">Retail</Option>
                <Option value="Other">Other</Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="email"
              label={<strong style={{ color: "#333" }}>Contact Email</strong>}
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email address" }
              ]}
            >
              <Input placeholder="you@example.com" />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>

      {/* Success Modal */}
      <Modal
        title={<strong><span style={{ fontSize: "20px" }}>Thank you for your request</span></strong>}
        closable={false}
        centered
        width={600}
        open={successModalVisible}
        onOk={handleSuccessOk}
        cancelButtonProps={{ style: { display: "none" } }}
        okText="Got it!"
        bodyStyle={{ padding: "24px" }}
      >
        <p>We’ve got your request! Someone from our team will connect with you soon. We’re looking forward to chatting.</p>
      </Modal>
    </div>
  );
};

export default Banner;